import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

// Global routes
export const globalIntegrationListRoute: InvariantJiraRoute = {
	name: 'eoc-integration-list',
	path: '/jira/settings/products/ops/integrations/list',
	exact: true,
};
